module.exports = __webpack_public_path__ + "static/media/bottom_banner_7_1.1725ae0d.png";